import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body pt-0" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "symbol symbol-45px me-5" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_11 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "svg-icon svg-icon-3" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'auctions'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.can('create', 'auctions'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('auctions-property-grouping-creating')))
                  }, [
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('addNewAuctionPropertyGrouping')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: auctionPropertyGrouping }) => [
              _createTextVNode(_toDisplayString(auctionPropertyGrouping.id), 1)
            ]),
            "cell-titleEn": _withCtx(({ row: auctionPropertyGrouping }) => [
              _createTextVNode(_toDisplayString(auctionPropertyGrouping.titleEn), 1)
            ]),
            "cell-titleAr": _withCtx(({ row: auctionPropertyGrouping }) => [
              _createTextVNode(_toDisplayString(auctionPropertyGrouping.titleAr), 1)
            ]),
            "cell-slug": _withCtx(({ row: auctionPropertyGrouping }) => [
              _createTextVNode(_toDisplayString(auctionPropertyGrouping.slug), 1)
            ]),
            "cell-icon": _withCtx(({ row: auctionPropertyGrouping }) => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    alt: "Pic",
                    src: auctionPropertyGrouping.icon
                  }, null, 8, _hoisted_9)
                ])
              ])
            ]),
            "cell-isActive": _withCtx(({ row: auctionPropertyGrouping }) => [
              (auctionPropertyGrouping.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-actions": _withCtx(({ row: auctionPropertyGrouping }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (
              _ctx.editAuctionPropertyGrouping(auctionPropertyGrouping.id)
            ), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_12),
              (_ctx.can('remove', 'auctions'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (
              _ctx.toggleStatusAuctionPropertyGrouping(auctionPropertyGrouping)
            ), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ], 8, _hoisted_14))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}